import React from "react";
import { MultiPickerListProps } from "../props";
import MultiPickerListWithSelectedItems from "../MultiPickerListWithSelectedItems";
import SubLabel from "components/Atoms/Sublabel";
import { getCityStateCountry } from "shared/utils/addressUtils";

const perPage = 20;

const MultiVenueList = (props: MultiPickerListProps<server.dto.VenueSmall>) => {
  const [instruction, setInstruction] = React.useState<server.dto.PaginatedVenueInstruction>({
    keyword: "",
    page: 1,
    perPage: perPage,
  });

  return <MultiPickerListWithSelectedItems
    instruction={instruction}
    onInstructionChange={setInstruction}
    queryKey="venuelist"
    api={window.CoreApi.Venue.PaginatedSmall}

    getError={() => undefined}
    excludeKeys={props.excludeKeys}

    onChange={props.onChange}
    renderListItem={venue => <div>
      <div>{venue.name}</div>
      <SubLabel>{getCityStateCountry(venue.address)}</SubLabel>
    </div>}
    getId={venue => venue.venueId}
    getLabel={venue => <div>{venue.name}</div>}
    value={props.value}
  />
};

export default MultiVenueList;